module.exports = __webpack_public_path__ + "static/media/reports_image1.d25977d8.webp";